<template>
  <div ref="container">
    <a-affix :offsetTop="0">
      <a-page-header
        style="border-bottom: 1px solid rgb(235, 237, 240); background: #fff"
        class="mb-5 px-0"
        :title="$t('product.create.title')"
        @back="() => $router.push({ name: 'catalogue.product.index' })"
      >
        <template slot="extra">
          <a-button type="primary" @click="$refs.form.submit()" :loading="saving">
            Save Product
          </a-button>
        </template>
      </a-page-header>
    </a-affix>

    <div>
      <ProductForm
        ref="form"
        hide-button
        @saved="saved"
      />
    </div>
  </div>
</template>

<script>
import ProductForm from '@/components/Product/Form/Index'

export default {
  name: 'CreateCatalogue',
  components: {
    ProductForm,
  },
  computed: {
    saving() {
      return this.$refs.form && this.$refs.form.saving
    },
  },
  methods: {
    saved(data) {
      return this.$router.push({ name: 'catalogue.product.index' })
        .then(() => {
          this.$notification.success({
            message: 'New product added',
            description: `Successfully added product "${data.product_title}"`,
            duration: 5,
          })
        })
    },
  },
}
</script>

<style>

</style>
